import React, { useState, useEffect } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { addDistrict, updateDistrict, setDistricts, setLoading, setError } from '../../../core/data/redux/stateDistrictSlice';
import { addDistrict as addDistrictService, updateDistrict as updateDistrictService, fetchDistricts } from '../../../core/data/services/stateDistrictBlockService';
import { District } from '../../../core/data/types/stateDistrict';

interface DistrictFormProps {
  show: boolean;
  onHide: () => void;
  district?: District;
  stateId: number;
}

const DistrictForm: React.FC<DistrictFormProps> = ({ show, onHide, district, stateId }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(district?.name || '');

  useEffect(() => {
    if (district) {
      setName(district.name);
    }
  }, [district]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(setLoading(true));
    try {
      let response;
      if (district) {
        const updatedDistrict = { id: district.id, name, stateId };
        response = await updateDistrictService(updatedDistrict);
        dispatch(updateDistrict(response));
      } else {
        response = await addDistrictService({ name, stateId });
        dispatch(addDistrict(response));
      }
      const districts = await fetchDistricts(stateId);
      console.log('Re-fetched districts after operation:', districts.length, districts); // Debug: Verify full list
      dispatch(setDistricts(districts));
      setName('');
      onHide();
    } catch (err: any) {
      dispatch(setError(err.message || 'Failed to save district'));
    } finally {
      dispatch(setLoading(false));
      setName('');

    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{district ? 'Edit District' : 'Add District'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>District Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            {district ? 'Update' : 'Add'} District
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default DistrictForm;